<template>
	<div>
		<div v-for='(item,ind) in timelist'>
			<a-row>
				<a-col :span='6'><div class='clas-font' :class='ind == 0?"cu-cla":""'>{{item.time}}</div></a-col>
				<a-col :span='6'><div style="text-align: right;" class='clas-font' :class='ind == 0?"cu-cla":""'>{{item.set}}</div></a-col>
				<a-col :span='12'><div style="text-align: right;padding-right: .4rem;" class='clas-font' :class='ind == 0?"cu-cla":""'>
				{{item.bnum}} <span v-if='item.a == "A"' style="color: red;">A</span>
				<span v-else-if='item.a == "B"' style="color: green;">B</span>
				<span v-else-if='item.a == "U"'>U</span></div></a-col>
			</a-row>
		</div>
	</div>
</template>

<script>
	export default{
		props:['timelist']
	}
</script>

<style lang="scss" scoped>
	.clas-font{
		font-size: 1.1rem;
		span{
			font-size: 1.1rem;
		}
	}
	.cu-cla{
		font-weight: 600;
		font-size: 1.3rem;
		span{
			font-size: 1.3rem;
		}
	}
</style>
